export const ACCIDENT_PRODUCT_LINES = [
  'accident',
  'accident-subsistence',
  'disability-subsistence',
  'accident-subsistence-jdc',
  'disability-subsistence-jdc'
]
